import Pattern from './Pattern';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Crosshair(_ref) {
  let {
    id,
    width,
    height,
    stroke = 'black',
    strokeWidth = 1,
    strokeDasharray,
    background,
    className,
    rotation = 0,
    gap = 10
  } = _ref;
  const halfGap = gap / 2;
  return /*#__PURE__*/_jsxs(Pattern, {
    id: id,
    width: gap,
    height: gap,
    children: [!!background && /*#__PURE__*/_jsx("rect", {
      width: gap,
      height: gap,
      fill: background
    }), /*#__PURE__*/_jsxs("g", {
      transform: `rotate(${rotation}, ${gap / 2}, ${gap / 2})`,
      children: [/*#__PURE__*/_jsx("line", {
        // Horizontal line
        x1: halfGap - width / 2,
        y1: halfGap,
        x2: halfGap + width / 2,
        y2: halfGap,
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeDasharray: strokeDasharray
      }), /*#__PURE__*/_jsx("line", {
        // Vertical line
        x1: halfGap,
        y1: halfGap - height / 2,
        x2: halfGap,
        y2: halfGap + height / 2,
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeDasharray: strokeDasharray
      })]
    })]
  });
}